import { ConvertGMTIST, amountFormate, formatDate, formatDateTime } from './AppHelper';
import { Badge } from 'primereact/badge';
import { Avatar } from 'primereact/avatar';
import moment from 'moment/moment';
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';

export const qtyTemplate = (rowData: any) => {
    return (
        <>
            <div>{rowData?.crop_qnty + ' ' + rowData?.weight_in}</div>
        </>
    );
};

//date TemplateFF
export const createdAtTemplate = (rowData: any) => {
    return (
        <>
            <div>{ConvertGMTIST(rowData?.created_at)}</div>
        </>
    );
};

export const emailTemplate = (rowData: any) => {
    return (
        <>
            <div>{rowData?.email}</div>
        </>
    );
};

export const mobileTemplate = (rowData: any) => {
    return (
        <>
            <div>{rowData?.mobile}</div>
        </>
    );
};

export const imageTemplate = (rowdata: any, imgUrl: any) => {
    return (
        <>
            {!window.cn(rowdata) && !window.cn(rowdata[imgUrl.field]) ? (
                <div className="main-img-box">
                    <img src={rowdata[imgUrl.field]} className="img-fluid" alt="main-img" />
                </div>
            ) : (
                <div className="main-img-box">
                    <img src="/assets/images/no-image.jpeg" width="50" height="40" alt="no-data-img" />
                </div>
            )}
        </>
    );
};

export const combinedFullNameTemplate = (rowData: any) => {
    return <>{rowData.StudL + ' ' + rowData.StudF + ' ' + rowData.StudM}</>;
};

export const applicationsFullNameTemplate = (rowData: any) => {
    return (
        <>
            <div className="avatar-div flex align-items-center">
                {!window.cn(rowData?.Image) ? <Avatar image={rowData?.Image} shape="circle" /> : <Avatar icon="pi pi-user" shape="circle" />}
                <div className="emp-name ml-2">{rowData?.full_name}</div>
            </div>
        </>
    );
};

export const othApplicationsFullNameTemplate = (rowData: any) => {
    return (
        <>
            <div className="avatar-div flex align-items-center">
                {!window.cn(rowData?.applicant_details.Image) ? <Avatar image={rowData?.applicant_details.Image} shape="circle" /> : <Avatar icon="pi pi-user" shape="circle" />}
                <div className="emp-name link-name ml-2">{rowData?.StudNm}</div>
            </div>
        </>
    );
};

export const collegeNameTemplate = (rowData: any) => {
    return (
        <>
            <div>
                <Button tooltip={rowData?.ColName} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">{rowData?.ColName}</div>
                </Button>
            </div>
        </>
    );
};

export const applicationsAppointmentDateTemplate = (rowData: any) => {
    return (
        <>
            <div>{!window.cn(rowData?.slot_data?.slot_details?.date) ? formatDateTime(rowData?.slot_data.slot_details.date) : '-'}</div>
        </>
    );
};

export const applicationsDOBTemplate = (rowData: any) => {
    return (
        <>
            <div>{!window.cn(rowData?.BOD) ? formatDateTime(rowData?.BOD) : '-'}</div>
        </>
    );
};

// Template for patment date
export const payDtTemplate = (rowData: any, rowIndex: any) => {
    return (
        <>
            <div>{!window.cn(rowData?.PayDt) ? formatDateTime(rowData?.PayDt) : '-'}</div>
        </>
    );
};

// Template for Reg No.
export const RegNoTemplate = (rowData: any, rowIndex: any) => {
    return <>{rowData?.RegNo}</>;
};

export const joiningYearTemplate = (rowData: any) => {
    return (
        <>
            <div>{!window.cn(rowData?.JoingYth) ? formatDateTime(rowData?.JoingYth) : '-'}</div>
        </>
    );
};

export const passingYearTemplate = (rowData: any) => {
    return (
        <>
            <div>{!window.cn(rowData?.Passedyth) ? formatDateTime(rowData?.Passedyth) : '-'}</div>
        </>
    );
};

export const EntDtTemplate = (rowData: any) => {
    return (
        <>
            <div>{!window.cn(rowData?.EntDt) ? formatDateTime(rowData?.EntDt) : '-'}</div>
        </>
    );
};

export const orgnameengTemplate = (rowData: any) => {
    return (
        <>
            <div>
                <Button tooltip={rowData?.orgnameeng} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">{rowData?.orgnameeng}</div>
                </Button>
            </div>
        </>
    );
};

export const courseNameTemplate = (rowData: any) => {
    return (
        <>
            <div>
                <Button tooltip={rowData?.refresher_course_name} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">{rowData?.refresher_course_name}</div>
                </Button>
            </div>
        </>
    );
};

export const courseIdTemplate = (rowData: any) => {
    const code = btoa(rowData?.id);
    
    return (
        <>
            <div className="avatar-div">
                <Link className="link-name" to={`/app/manage-refresher-course/${code}`}>{rowData?.id}</Link>
            </div>
        </>
    );
};

export const courseStartTemplate = (rowData: any) => {
    return (
        <>
            <div>{!window.cn(rowData?.start_date) ? formatDateTime(rowData?.start_date) : '-'}</div>
        </>
    );
};

export const courseEndTemplate = (rowData: any) => {
    return (
        <>
            <div>{!window.cn(rowData?.end_date) ? formatDateTime(rowData?.end_date) : '-'}</div>
        </>
    );
};

export const verifiedByTemplate = (rowData: any) => {
    let verifiedBy = rowData?.verified_by;
    if (!window.cn(verifiedBy)) {
        verifiedBy = verifiedBy.split(' ')[0];
    }
    return (
        <>
            <div>{verifiedBy}</div>
        </>
    );
};

// Template for remark
export const remarkTemplate = (rowData: any, rowIndex: any) => {
    return (
        <>
            <div>
                <Button tooltip={rowData?.Message} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">{rowData?.Message}</div>
                </Button>
            </div>
        </>
    );
};

// Template for debit
export const debitTemplate = (rowData: any, rowIndex: any) => {
    return <>{!window.cn(rowData.Debit) ? rowData.Debit + '.00' : '0.00'}</>;
};

// Template for credit
export const creditTemplate = (rowData: any, rowIndex: any) => {
    return <>{!window.cn(rowData.Credit) ? rowData.Credit + '.00' : '0.00'}</>;
};

//Template FOR COMMMON TOOLTIP

export const commonNameTemplate = (rowData: any, rowIndex: any) => {
    return (
        <>
            <div>
                <Button tooltip={rowData[rowIndex.field]} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">{rowData[rowIndex.field]}</div>
                </Button>
            </div>
        </>
    );
};

//Template FOR COMMMON TOOLTIP

export const commonMultipleTemplate = (rowData: any, rowIndex: any) => {
    return (
        <>
            <div className="college-name-div">{rowData[rowIndex.field]}</div>
        </>
    );
};

//Template FOR date

export const dateTemplate = (rowData: any, rowIndex: any) => {
    return (
        <>
            <div>{formatDateTime(rowData[rowIndex.field])}</div>
        </>
    );
};

// Template for Reg Dt.
export const RegDtTemplate = (rowData: any, rowIndex: any) => {
    return <>{!window.cn(rowData.RegDt) ? formatDate(rowData.RegDt) : ''}</>;
};

// Total Amount Formet Template
export const amountCommonTemplate = (rowData: any, rowIndex: any) => {
    return (
        <>
            <div>{rowData[rowIndex.field]}</div>
        </>
    );
};

// Total Amount Formet Template
export const amountTemplate = (rowData: any, rowIndex: any) => {
    return (
        <>
            <div>{amountFormate(rowData[rowIndex.field])}</div>
        </>
    );
};

export const commonImageTemplate = (rowdata: any, rowIndex: any) => {
    return (
        <>
            {!window.cn(rowdata) ? (
                <div className="main-img-box">
                    <img src={rowdata[rowIndex.field]} className="img-fluid" alt="main-img" />
                </div>
            ) : (
                <div className="main-img-box">
                    <img src="/assets/images/no-image.jpeg" width="50" height="40" alt="no-data-img" />
                </div>
            )}
        </>
    );
};

// pdfTemplate

export const pdfTemplate = (rowData: any, rowIndex: any) => {
    return (
        <>
            <div className="actions">
                <a href={rowData[rowIndex.field]} target="_blank">
                    <i className="pi pi-file-pdf pdf-temp"></i>
                </a>
            </div>
        </>
    );
};
